import * as z from 'zod'
import { pt } from 'zod/locales'

export function initializeZodErrorMap(): void {
  z.config({
    ...pt,
    customError: (iss) => {
      switch (iss.code) {
        case 'invalid_type':
          if (iss.input === undefined || iss.input === null) {
            return 'Campo obrigatório'
          }
          return 'Tipo inválido'

        case 'invalid_format':
          if ('format' in iss) {
            if (iss.format === 'email') {
              return 'E-mail inválido'
            }
            if (iss.format === 'url') {
              return 'URL inválida'
            }
            if (iss.format === 'uuid') {
              return 'UUID inválido'
            }
          }
          return 'Formato inválido'

        case 'too_small':
          if (iss.type === 'string') {
            if (iss.minimum === 1) {
              return 'Campo obrigatório'
            }
            return `Mínimo ${iss.minimum} caracteres`
          }
          if (iss.type === 'number') {
            return `Mínimo: ${iss.minimum}`
          }
          if (iss.type === 'array') {
            return `Mínimo ${iss.minimum} ${iss.minimum === 1 ? 'item' : 'itens'}`
          }
          return 'Campo obrigatório'

        case 'too_big':
          if (iss.type === 'string') {
            return `Máximo ${iss.maximum} caracteres`
          }
          if (iss.type === 'number') {
            return `Máximo: ${iss.maximum}`
          }
          if (iss.type === 'array') {
            return `Máximo ${iss.maximum} ${iss.maximum === 1 ? 'item' : 'itens'}`
          }
          return 'Muito longo'

        case 'invalid_value':
          return 'Valor inválido'

        case 'unrecognized_keys':
          if ('keys' in iss) {
            return `Campos não reconhecidos: ${iss.keys.join(', ')}`
          }
          return 'Campos não reconhecidos'

        case 'invalid_union':
          return 'Valor inválido'

        case 'not_multiple_of':
          if ('multipleOf' in iss) {
            return `Deve ser múltiplo de ${iss.multipleOf}`
          }
          return 'Valor inválido'

        case 'custom':
          return undefined

        default:
          return undefined
      }
    },
  })
}
